module.exports = __webpack_public_path__ + "assets/d7c594fb6f6a46b037eefe4befda8d2b.png";